import React from 'react';
import useFetch from '../../../api/useFetch';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { ExoAiOriginChip } from '../ExoAiOriginChip';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { API_DELETE, API_GET, DBRequest, useConfig } from '../../../api/api';
import DateTimeLabel from '../../label/DateTimeLabel';
import ExoTable from '../ExoTable';
import MoneyLabel from '../../label/MoneyLabel';

export const DINLoader = ({ onSelect }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const { apiData, setApiData } = useFetch('din');

  const columns = [
    {
      header: '',
      key: 'createdByAi',
      width: '30px',
      tdAlign: 'center',
      cell: ({ row }) => <ExoAiOriginChip record={row} compact />,
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Creditable Costs'),
      key: 'totalCost',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      //width: "270px",
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">
          <MoneyLabel money={row.totalCost} />
        </Typography>
      ),
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Last Change'),
      key: 'updatedAt',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      //width: "270px",
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">
          <DateTimeLabel dateTime={row.updatedAt} />
        </Typography>
      ),
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Delete'),
      key: 'delete',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: '100px',
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <IconButton onClick={() => handleDelete(row)}>
          <DeleteIcon />
        </IconButton>
      ),
      //onClick: (row) => handleSelect(row),
    },
  ];

  function handleDelete(row) {
    DBRequest({
      config,
      path: `din/${row.id}`,
      method: API_DELETE(),
      onResponse: () => handleDeleteResponse(row),
    });
  }

  function handleDeleteResponse(row) {
    const newData = apiData.data.filter((el) => el.id != row.id);
    setApiData({ data: newData });
  }

  function handleSelect(row) {
    DBRequest({
      config,
      path: `din/${row.id}`,
      method: API_GET,
      onResponse: onSelect,
    });
  }

  return (
    <Box className="px-5">
      <Typography className="py-5" variant="h3">
        {t('Load DIN276 Presets')}
      </Typography>
      <ExoTable data={apiData} columns={columns} />
    </Box>
  );
};
